import { ReactNode } from "react";
import { useKeycloak } from "providers/KeycloakProvider";
import { Navigate } from "react-router-dom";

interface AdvisorGuardProps {
  children: ReactNode;
  /** Redirect path when user doesn't have advisor access */
  redirectTo?: string;
}

/**
 * Guard component that checks if the user has advisor access rights.
 * If the user doesn't have the 'advisor' access flag, they will be
 * redirected to the specified path (defaults to overview).
 *
 * The advisor access is controlled by the 'enableAdvisor' role configuration
 * in keycloak.json.
 *
 * @param children - The protected content to render
 * @param redirectTo - Path to redirect unauthorized users (default: "/overview")
 */
export const AdvisorGuard = ({
  children,
  redirectTo = "/overview",
}: AdvisorGuardProps) => {
  const { access } = useKeycloak();

  // TODO: Add additional advisor access validation logic here if needed
  // For example, checking specific advisor attributes or permissions
  const hasAdvisorAccess = access.advisor;

  if (!hasAdvisorAccess) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};
